import ExternalLinkButton from 'src/Components/shared/ExternalLinkButton'
import Text from 'src/Components/shared/Text'
import styles from './ListingsEmptyState.module.scss'
import { ListingsEmptyStateIllustration } from './ListingsEmptyStateIllustration'
import { FormattedMessage } from 'react-intl'

export const ListingsEmptyState = () => {
  return (
    <div className={styles.bodyWrapper}>
      <div className={styles.body}>
        <ListingsEmptyStateIllustration />
        <Text
          className={styles.headerText}
          align='center'
          size='l'
          weight='bold'
        >
          <FormattedMessage
            id='HomeSearch.listings.emptyState.title'
            defaultMessage="We couldn't find any homes matching your search"
          />
        </Text>
        <div>
          <Text
            className={styles.descriptionTopText}
            align='center'
            variant='neutralCool'
            variantCount='700'
            size='s'
          >
            <FormattedMessage
              id='HomeSearch.listings.emptyState.tryZooming'
              defaultMessage='You can try zooming out and adjusting your filters'
            />
          </Text>
          <Text
            className={styles.orText}
            align='center'
            variant='neutralCool'
            variantCount='700'
            size='s'
            weight='bold'
          >
            <FormattedMessage
              id='HomeSearch.listings.emptyState.or'
              defaultMessage='— OR —'
            />
          </Text>
          <Text
            className={styles.descriptionBottomText}
            align='center'
            variant='neutralCool'
            variantCount='700'
            size='s'
          >
            <FormattedMessage
              id='HomeSearch.listings.emptyState.checkoutHB4C'
              defaultMessage='Check out Homebot for Chrome to get insights on other listing sites'
            />
          </Text>
        </div>
        <ExternalLinkButton
          primary
          href='https://chrome.google.com/webstore/detail/homebot-for-chrome/oigjeliojmhdahlmjhackoknjmohedfi'
        >
          <FormattedMessage
            id='HomeSearch.listings.emptyState.checkoutHB4CButtonText'
            defaultMessage='Check out Homebot for Chrome'
          />
        </ExternalLinkButton>
      </div>
    </div>
  )
}
